import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { CurrencyInput } from '@components/core-ui/form-elements/CurrencyInput';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { useModalContext } from '@providers/ModalProvider';
import { AdminService } from 'app/API';
import { useState } from 'react';

import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { Content } from './AddBalanceToBillingAccount/styles/Content';

type TProps = {
  billingAccountId: string;
  onCancel: () => void;
  onSuccess: () => void;
};

export const AdminAddBalanceToBillingAccountModal = ({ billingAccountId, onCancel, onSuccess }: TProps) => {
  const { closeModal } = useModalContext();
  const { call } = useAPI();
  const [amount, setAmount] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<{
    error: string;
    errorDetail: string;
  } | null>(null);

  const onSubmit = async () => {
    setError(null);
    setIsLoading(true);
    await call(
      AdminService.addMainBalanceToBillingAccount({ baId: billingAccountId, requestBody: { amount: amount * 100 } }),
    );
    setIsLoading(false);
    closeModal();
    onSuccess();
  };

  const isSubmitDisabled = isLoading || amount === 0 || amount > 50;

  return (
    <ModalWrapper width="400px">
      {isLoading ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Add Goodwill Credit</ModalTitle>
      <Content>
        <div className="input-wrapper">
          <div className="label">Amount (USD)</div>
          <div className="description">
            Maximum amount is $50.00. <br />
            This will be added to the separate Free Credit balance
          </div>
          <div className="flex flex-row">
            <CurrencyInput
              onChange={(v) => {
                setError(null);
                if (!v) {
                  setAmount(0);
                  return;
                }
                setAmount(v);
              }}
              label="Amount"
              value={amount}
            />
          </div>
        </div>

        {error ? (
          <div className="error">
            <p>{error.errorDetail}</p>
          </div>
        ) : null}
        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button disabled={isSubmitDisabled} onClick={onSubmit}>
            Add funds
          </Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
